import {Ventrata} from 'types'
import {getDiscountDetails} from './getDiscountDetails'
import {getSubtotalAmount} from './getSubtotalAmount'

export const getTotalAmount = (order: Ventrata.Order) => {
  const discountDetails = getDiscountDetails(order)
  const voucherAmount = discountDetails?.type === 'voucher' ? discountDetails.value : 0
  const subtotalAmount = getSubtotalAmount(order)

  if (voucherAmount) {
    return subtotalAmount - voucherAmount
  }

  return subtotalAmount
}
